export default {
  namespaced: true,
  state: {
    // 缓存tab页
    tabs: [],
    // 非缓存Tab
    excludeTabs: [],
    // 一级routerview刷新key
    staticTabs: ['LayoutPageRoute', 'CommonRefresh'],
    // 当前活动状态Tab
    activeTab: {
      index: -1,
      tab: {},
    },
  },
  getters: {
    // 缓存tab页 Name
    tabNames(state) {
      return [
        ...state.tabs.map((item) => item.name).filter((item) => !!item),
        ...state.staticTabs,
      ].filter((item) => !state.excludeTabs.includes(item))
    },
  },
  mutations: {
    setStaticTabs(state, value = []) {
      state.staticTabs = value
    },
    // 是否包含指定id
    hasTab(state, route = {}) {
      const res = state.tabs.find((item) => item.id === route.path)
      return res
    },
    // 更新非缓存页签
    setExcludeTabs(state, value) {
      state.excludeTabs = value || []
    },
    // 插入页签
    insertTab(state, tab = {}) {
      const config = {
        tabIndex: -1,
        n: 0,
        ...tab,
      }
      const { tabIndex, n, ...data } = config
      if (tabIndex >= 0) {
        state.tabs.splice(tabIndex, n, data)
      }
    },
    // 更新当前活动tab
    setActiveTab(state, obj) {
      state.activeTab = obj || {
        index: -1,
        tab: {},
      }
    },
    // 更新页签组
    setTabs(state, tabs = []) {
      state.tabs = tabs
    },
    // 选择/新增页签
    selectTab(state, tabData = {}) {
      if (!tabData) {
        return
      }
      if (tabData.name === 'CommonRefresh') {
        return
      }
      let { ...tab } = tabData

      let existTabIndex = -1
      state.tabs.map((item, index) => {
        item.active = item.id === tab.id
        if (item.active) {
          existTabIndex = index
        }
        return item
      })
      // 页签不存在-新增
      if (existTabIndex < 0) {
        tab.active = true
        state.tabs.push(tab)
        this.commit('tabs/setActiveTab', {
          index: state.tabs.length - 1,
          tab: tab,
        })
      } else {
        // 页签存在-更新 (同路由不同参数更新缓存)
        Object.entries(tab).forEach(([key, value]) => {
          state.tabs[existTabIndex][key] = value
        })
        this.commit('tabs/setActiveTab', {
          index: existTabIndex,
          tab: tab,
        })
      }
    },
    // 关闭/移除页签
    removeTab(state, index, n = 1) {
      state.tabs.splice(index, n)
    },
    removeTabByName(state, name) {
      const index = state.tabs.findIndex((item) => item.name === name)
      if (index > -1) {
        state.tabs.splice(index, 1)
      }
    },
  },
}
